import { render, staticRenderFns } from "./ShopUploadsList.vue?vue&type=template&id=f57b0430"
import script from "./ShopUploadsList.vue?vue&type=script&lang=js"
export * from "./ShopUploadsList.vue?vue&type=script&lang=js"
import style0 from "./ShopUploadsList.vue?vue&type=style&index=0&id=f57b0430&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports